/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchPhotoAdjudication
 */
export interface MatchPhotoAdjudication {
    /**
     * 
     * @type {number}
     * @memberof MatchPhotoAdjudication
     */
    analyzedAt: number;
    /**
     * Whether the parsed winner corroborates the standing score's winner
     * @type {boolean}
     * @memberof MatchPhotoAdjudication
     */
    agrees?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MatchPhotoAdjudication
     */
    team1Score?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchPhotoAdjudication
     */
    team2Score?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchPhotoAdjudication
     */
    winnerTeamId?: string;
    /**
     * Why the parse could not be mapped (ambiguous names, draw, unreadable, ...)
     * @type {string}
     * @memberof MatchPhotoAdjudication
     */
    reason?: string;
}

/**
 * Check if a given object implements the MatchPhotoAdjudication interface.
 */
export function instanceOfMatchPhotoAdjudication(value: object): value is MatchPhotoAdjudication {
    if (!('analyzedAt' in value) || value['analyzedAt'] === undefined) return false;
    return true;
}

export function MatchPhotoAdjudicationFromJSON(json: any): MatchPhotoAdjudication {
    return MatchPhotoAdjudicationFromJSONTyped(json, false);
}

export function MatchPhotoAdjudicationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchPhotoAdjudication {
    if (json == null) {
        return json;
    }
    return {
        
        'analyzedAt': json['analyzedAt'],
        'agrees': json['agrees'] == null ? undefined : json['agrees'],
        'team1Score': json['team1Score'] == null ? undefined : json['team1Score'],
        'team2Score': json['team2Score'] == null ? undefined : json['team2Score'],
        'winnerTeamId': json['winnerTeamId'] == null ? undefined : json['winnerTeamId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function MatchPhotoAdjudicationToJSON(json: any): MatchPhotoAdjudication {
    return MatchPhotoAdjudicationToJSONTyped(json, false);
}

export function MatchPhotoAdjudicationToJSONTyped(value?: MatchPhotoAdjudication | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'analyzedAt': value['analyzedAt'],
        'agrees': value['agrees'],
        'team1Score': value['team1Score'],
        'team2Score': value['team2Score'],
        'winnerTeamId': value['winnerTeamId'],
        'reason': value['reason'],
    };
}

